export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./pins.vue?vue&type=template&id=2728805d&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/players/player/pins.vue?vue&type=template&id=2728805d&scoped=true
// module id = oZlv
// module chunks = 0